import useAddress from 'hooks/useAddress';
import { setBalance, setChainAddress } from 'state/global';
import { ProviderWindow } from 'types/types';
import { ethers } from 'ethers';
import { Dec } from '@terra-money/terra.js';
import { toChainAmount } from 'functions/toXAmount';
import { useEffect } from 'react';
import {
  ConnectType,
  useLCDClient,
  useWallet,
} from "@terra-money/wallet-provider";
import { DeviceType, deviceType } from "functions/deviceType";

declare var window: any;

const ProviderWrapper = ({ children }: any) => {
  const { connect, connection, availableConnections } = useWallet();
  const user_address = useAddress();
  const LCD = useLCDClient();

  const getSetBalances = async () => {
    const [coins] = await LCD.bank.balance(user_address);

    const [uusd_balance] = coins
      .toData()
      .filter((coin) => coin.denom === "uusd");
    const [uluna_balance] = coins
      .toData()
      .filter((coin) => coin.denom === "uluna");

    setBalance("uusd", uusd_balance ? +uusd_balance.amount : 0);
    setBalance("uluna", uluna_balance ? +uluna_balance.amount : 0);

    if (connection?.name === "XDEFI Wallet") {
      const xwindow = window as ProviderWindow;
      const provider = new ethers.providers.Web3Provider(
        xwindow.xfi?.ethereum!
      );

      const signer = provider.getSigner();
      const address = await signer.getAddress();
      const wei_balance = await signer.getBalance();
      const eth_balance = new Dec(parseInt(wei_balance.toHexString(), 16))
        .div(1e18)
        .toNumber();

      setBalance("eth", toChainAmount(eth_balance));
      setChainAddress("network", "xdefi");
      setChainAddress("address", address);
    }
  };

  const resetBalances = () => {
    setBalance("uusd", 0);
    setBalance("uluna", 0);
    setBalance("eth", 0);
    setChainAddress("address", "");
    setChainAddress("network", "");
  };

  useEffect(() => {
    user_address ? getSetBalances() : resetBalances();
  }, [user_address]);

  return <>{children}</>;
};

export default ProviderWrapper;